export const meta = {
  slug: { de: "telefonservice-praxis-sinnvoll", en: "phone-service-for-practices-when-it-helps" },
  title: "Telefonservice für die Praxis: wann er wirklich entlastet",
  excerpt:
    "Ein externer Telefonservice ist nur dann eine Entlastung, wenn er die Sprache, die Abläufe und die Verantwortung der Praxis ruhig mitträgt.",
  category: "praxen",
  publishedAt: "2026-04-12",
  updatedAt: "2026-05-06",
  metaTitle: "Wann ein Telefonservice sinnvoll ist | OnePractix",
  metaDescription:
    "Wann ein Telefonservice eine Praxis wirklich entlastet, worauf bei der Auswahl zu achten ist und welche Strukturen im Hintergrund nötig sind.",
  related: ["patientenanfragen-effizient-bearbeiten", "praxisorganisation-verbessern"],
  en: {
    title: "When a phone service helps practices",
    metaTitle: "When a phone service helps practices | OnePractix",
    metaDescription:
      "When a phone service really relieves a practice, what to look for when choosing one, and which structures are needed in the background.",
    excerpt:
      "An external phone service only relieves a practice when it carries the language, workflows and responsibility of the practice calmly with it.",
  },
};

export default meta;
